"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRippleStyles = exports.useStyles = void 0;

require("core-js/modules/es.object.define-property.js");

var _core = require("../core");

var _utils = require("../utils");

var _theme = require("../theme/theme.utils");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _utils.createStylesHook)()(function (theme) {
  return {
    focusVisible: {},
    root: _defineProperty({
      '&:hover': {
        backgroundColor: theme.palette.primary.lightest
      }
    }, _theme.overrideClasses.focusVisible, {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.primary.lighterPlus
    })
  };
}, {
  name: (0, _core.rochePrefix)('Tab')
});
exports.useStyles = useStyles;
var useRippleStyles = (0, _utils.createStylesHook)()(function (theme) {
  return {
    child: {
      backgroundColor: theme.palette.primary.alt
    }
  };
}, {
  name: (0, _core.rochePrefix)('Ripple')
});
exports.useRippleStyles = useRippleStyles;